interface BoxWithDiscInsideAndClockSVGProps {
  color: string;
  style: React.CSSProperties;
}

const BoxWithDiscInsideAndClockSVG = ({
  color,
  style,
}: BoxWithDiscInsideAndClockSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="47"
    height="50"
    viewBox="0 0 47 50"
    fill="none"
  >
    <g clipPath="url(#clip0_3458_10141)">
      <path
        d="M36.386 12.6865L24.5059 19.553"
        stroke={color}
        strokeWidth="1.01726"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.1849 19.5351L6.33203 12.6868L10.2648 10.4434"
        stroke={color}
        strokeWidth="1.01726"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.0605 36.592L21.3638 38.7264L6.33203 30.0434V19.4258"
        stroke={color}
        strokeWidth="1.01726"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.3867 19.6533V26.1202"
        stroke={color}
        strokeWidth="1.01726"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.3652 25.1025V32.8955"
        stroke={color}
        strokeWidth="1.01726"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.3652 21.3702L27.1781 24.7308L42.2099 16.0478L36.3879 12.6872L32.3916 10.3711"
        stroke={color}
        strokeWidth="1.01726"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.33175 12.6865L0.509766 16.0471L15.5416 24.7301L21.3635 21.3695"
        stroke={color}
        strokeWidth="1.01726"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9085 15.3388C10.4907 14.1671 10.2637 12.9137 10.2637 11.5968C10.2637 5.47505 15.2319 0.506836 21.3627 0.506836C27.4935 0.506836 32.4526 5.47505 32.4526 11.5968C32.4526 12.9047 32.2255 14.1671 31.8077 15.3388"
        stroke={color}
        strokeWidth="1.01726"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.0611 11.597C24.0611 13.0865 22.8531 14.2945 21.3636 14.2945C19.874 14.2945 18.666 13.0865 18.666 11.597C18.666 10.1074 19.874 8.89941 21.3636 8.89941C22.8531 8.89941 24.0611 10.1074 24.0611 11.597Z"
        stroke={color}
        strokeWidth="1.01726"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.1953 11.5967C27.1953 14.821 24.5795 17.4278 21.3643 17.4278C18.149 17.4278 15.5332 14.8119 15.5332 11.5967C15.5332 8.38143 18.149 5.76562 21.3643 5.76562C24.5795 5.76562 27.1953 8.38143 27.1953 11.5967Z"
        stroke={color}
        strokeWidth="1.01726"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.0188 6.25609L16.957 1.41504"
        stroke={color}
        strokeWidth="1.01726"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.6426 6.25609L25.6953 1.41504"
        stroke={color}
        strokeWidth="1.01726"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.2959 30.4092C41.5638 30.4092 45.8417 34.678 45.8417 39.955C45.8417 45.2321 41.5729 49.5009 36.2959 49.5009C31.0188 49.5009 26.75 45.2321 26.75 39.955C26.75 35.4046 29.938 31.5899 34.2069 30.6453"
        stroke={color}
        strokeWidth="1.01726"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.4004 30.1006C43.3541 30.691 44.2078 31.4085 44.9526 32.2441"
        stroke={color}
        strokeWidth="1.01726"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.207 30.6179V28.7832C34.207 28.3654 34.5431 28.0293 34.9609 28.0293H37.6221C38.0399 28.0293 38.376 28.3654 38.376 28.7832V30.6179"
        stroke={color}
        strokeWidth="1.01726"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.296 46.8752C40.1183 46.8752 43.217 43.7765 43.217 39.9542C43.217 36.1318 40.1183 33.0332 36.296 33.0332C32.4736 33.0332 29.375 36.1318 29.375 39.9542C29.375 43.7765 32.4736 46.8752 36.296 46.8752Z"
        stroke={color}
        strokeWidth="1.01726"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.7628 31.0898L42.4004 32.6157"
        stroke={color}
        strokeWidth="1.01726"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.9917 30.1006C29.038 30.691 28.1842 31.4085 27.4395 32.2441"
        stroke={color}
        strokeWidth="1.01726"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.6211 31.0898L29.9926 32.6157"
        stroke={color}
        strokeWidth="1.01726"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.2949 34.6963V36.0587"
        stroke={color}
        strokeWidth="1.01726"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.6621 35.4043L34.3524 36.585"
        stroke={color}
        strokeWidth="1.01726"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.7363 37.3213L32.9262 38.0116"
        stroke={color}
        strokeWidth="1.01726"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.0371 39.9551H32.3995"
        stroke={color}
        strokeWidth="1.01726"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.7363 42.5887L32.9262 41.8984"
        stroke={color}
        strokeWidth="1.01726"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.6621 44.505L34.3524 43.3242"
        stroke={color}
        strokeWidth="1.01726"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.2949 45.2143V43.8428"
        stroke={color}
        strokeWidth="1.01726"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.9214 44.505L38.2402 43.3242"
        stroke={color}
        strokeWidth="1.01726"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.8468 42.5887L39.666 41.8984"
        stroke={color}
        strokeWidth="1.01726"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.5531 39.9551H40.1816"
        stroke={color}
        strokeWidth="1.01726"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.8468 37.3213L39.666 38.0116"
        stroke={color}
        strokeWidth="1.01726"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.9209 35.4043L36.4141 39.9547"
        stroke={color}
        strokeWidth="1.01726"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3458_10141">
        <rect width="46.3397" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default BoxWithDiscInsideAndClockSVG;
